import { SymbolLayerSpecification, FillLayerSpecification, LineLayerSpecification } from "@iventis/mapbox-gl";

export const cadSourceId = "cad-source";

export const cadFillLayer: FillLayerSpecification = {
    id: "fill-layer",
    type: "fill",
    paint: {
        "fill-opacity": 0.7,
        "fill-color": "green",
    },
    source: cadSourceId,
    "source-layer": cadSourceId,
    filter: ["==", "$type", "Polygon"],
};

export const cadLineLayer: LineLayerSpecification = {
    id: "line-layer",
    type: "line",
    paint: {
        "line-color": "red",
        "line-width": 1,
        "line-opacity": 0.7,
    },
    "source-layer": cadSourceId,
    source: cadSourceId,
    filter: ["==", "$type", "LineString"],
};

export const cadTextLayer: SymbolLayerSpecification = {
    id: "text-layer",
    type: "symbol",
    layout: {
        "text-field": ["get", "text"],
    },
    source: cadSourceId,
    "source-layer": cadSourceId,
    filter: ["==", "$type", "Point"],
};
